import dayjs from "dayjs";

export const formatDateTime = (dateInput) => {
  if (!dateInput) return "--";
  const date = dayjs(dateInput);
  if (!date.isValid()) return "--";

  const timeFormatted = date
    .format("hh:mm A")
    .replace("AM", "Am")
    .replace("PM", "Pm");
  return `${date.format("MMM DD, YYYY")}, ${timeFormatted}`;
};

export const formatDateTimeWithToday = (dateInput) => {
  if (!dateInput) return "--";
  const date = dayjs(dateInput);
  if (!date.isValid()) return "--";

  const timeFormatted = date
    .format("hh:mm A")
    .replace("AM", "Am")
    .replace("PM", "Pm");
  const isToday = date.isSame(dayjs(), "day");

  if (isToday) {
    return `Today, ${timeFormatted}`;
  }
  return `${date.format("MMM DD, YYYY")}, ${timeFormatted}`;
};

export default formatDateTimeWithToday;
